import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Book, Video, Users, Phone, CalendarDays, MessageSquareText } from "lucide-react";

export const SupportResources = () => {
  return (
    <div className="space-y-8 animate-fade-in">
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="p-6">
          <h3 className="text-xl font-semibold mb-4">Educational Resources</h3>
          <div className="space-y-4">
            <Button className="w-full flex items-center gap-2" variant="outline">
              <Book className="w-4 h-4" />
              Learning Library
            </Button>
            <Button className="w-full flex items-center gap-2" variant="outline">
              <Video className="w-4 h-4" />
              Video Tutorials
            </Button>
            <Button className="w-full flex items-center gap-2" variant="outline">
              <Users className="w-4 h-4" />
              Expert Talks
            </Button>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-xl font-semibold mb-4">Support Groups</h3>
          <div className="space-y-4">
            <Button className="w-full flex items-center gap-2" variant="outline">
              <Users className="w-4 h-4" />
              Find Groups
            </Button>
            <Button className="w-full flex items-center gap-2" variant="outline">
              <CalendarDays className="w-4 h-4" />
              Upcoming Events
            </Button>
            <Button className="w-full flex items-center gap-2" variant="outline">
              <MessageSquareText className="w-4 h-4" />
              Community Forum
            </Button>
          </div>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="text-xl font-semibold mb-4">Help & Support</h3>
        <div className="space-y-4">
          <Button className="w-full" variant="outline">Contact Support</Button>
          <Button className="w-full" variant="outline">FAQs</Button>
          <Button className="w-full" variant="outline">Crisis Resources</Button>
        </div>
      </Card>
    </div>
  );
};